const translations = {
  common: {
    search: 'Поиск',
    searching: 'Поиск',
    signIn: 'Войти',
    register: 'Регистрация',
    myAccount: 'Мой аккаунт',
    support: 'Поддержка',
    followUs: 'Подписывайтесь на нас в X/Twitter',
    proMembership: 'Pro-подписка',
    new: 'Новое',
    proMember: 'Pro-участник',
    upgrade: 'Улучшить',
    subscribe: 'Подписаться',
    manage: 'Управлять',
    cancel: 'Отмена',
    close: 'Закрыть',
    or: 'Или',
    email: 'Электронная почта',
    continue: 'Продолжить',
    submit: 'Отправить',
    billing: 'Оплата',
    sort: 'Сортировка',
    language: 'Язык',
    selectLanguage: 'Выбрать язык',
    searchPlaceholder: 'Поиск...',
    cards: 'Карты',
    previous: 'Предыдущая',
    next: 'Следующая',
    pagination: 'Пагинация',
    back: 'Назад',
    backToSets: 'Назад к сетам',
    error: 'Произошла ошибка. Пожалуйста, попробуйте снова.',
    home: 'Главная',
    sets: 'Сеты',
    login: 'Войти',
    loginRequired: 'Пожалуйста, войдите для доступа к этой функции',
    adding: 'Добавление...',
  },
  languages: {
    default: 'По умолчанию',
    any: 'Любой',
    english: 'Английский',
    spanish: 'Испанский',
    french: 'Французский',
    german: 'Немецкий',
    italian: 'Итальянский',
    portuguese: 'Португальский',
    japanese: 'Японский',
    korean: 'Корейский',
    russian: 'Русский',
    simplified_chinese: 'Упрощенный китайский',
    traditional_chinese: 'Традиционный китайский',
    hebrew: 'Иврит',
    latin: 'Латинский',
    ancient_greek: 'Древнегреческий',
    arabic: 'Арабский',
    sanskrit: 'Санскрит',
    phyrexian: 'Фирексийский',
    quenya: 'Квенья',
  },
  filters: {
    show: '✨ Показать Pro фильтры',
    hide: '✨ Скрыть Pro фильтры',
  },
  search: {
    showing_start: 'Показано',
    showing_to: 'до',
    showing_of: 'из',
    showing_results: 'результатов',
    noResults: 'Результаты не найдены.',
    useSearchTip: 'Используйте поиск вверху страницы, чтобы найти карту.',
  },
  sort: {
    nameAsc: 'Имя (А до Я)',
    nameDesc: 'Имя (Я до А)',
    cmcAsc: 'Мана-стоимость (по возрастанию)',
    cmcDesc: 'Мана-стоимость (по убыванию)',
    usdAsc: 'Цена (по возрастанию)',
    usdDesc: 'Цена (по убыванию)',
    rarityAsc: 'Редкость (от обычной до мифической)',
    rarityDesc: 'Редкость (от мифической до обычной)',
    releasedDesc: 'Дата выпуска (сначала новые)',
    releasedAsc: 'Дата выпуска (сначала старые)',
  },
  pages: {
    search: {
      heading: 'Поиск карт MTG',
    },
    sets: {
      heading: 'Наборы карт',
      latestSets: 'Последние наборы',
      upcomingSets: 'Предстоящие наборы',
      allSets: 'Все наборы',
      noResults: 'Результаты не найдены.',
    },
    set: {
      notFound: 'Набор не найден.',
      noCards: 'В этом наборе не найдено карт.',
      addAll: 'Добавить {{count}} карт в список прокси',
      addedToList: 'Добавлено {{count}} карт в список прокси',
    },
    tokens: {
      heading: 'Токены',
    },
    emblems: {
      heading: 'Эмблемы',
    },
    import: {
      heading: 'Импорт карт в список прокси',
      description: 'Введите названия всех карт, которые вы хотите добавить в список прокси.',
    },
    topProxies: {
      heading: 'Популярные прокси',
      description: 'Вот 50 самых популярных прокси-карт MTG на TCG Stacked.',
    },
  },
  theme: {
    light: 'Светлая',
    dark: 'Тёмная',
    toggle: 'Переключить тему',
  },
  cta: {
    title: 'Готовы начать?',
    subtitle: 'Начните создавать прокси карты уже сегодня.',
    searchByCard: 'Поиск по карте',
    searchBySet: 'Поиск по набору',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Покемон',
    sets: 'Сеты',
    tokens: 'Токены',
    emblems: 'Эмблемы',
    import: 'Импорт',
    topProxies: 'Популярные прокси',
    customCards: 'Пользовательские карты',
    deckBuilder: 'Конструктор колод',
    buildDeck: 'Создать колоду',
    publicDecks: 'Публичные колоды',
    favoriteDeck: 'Мои избранные колоды',
    articles: 'Статьи',
    feedback: 'Поделиться отзывом',
    collection: 'Моя коллекция',
    pokemonSets: 'Сеты Покемон',
    pokemonSearch: 'Поиск карт Покемон',
  },
  seo: {
    collection: {
      title: 'Моя коллекция карт | TCG Stacked',
      description: 'Управляйте своей личной коллекцией карт. Отслеживайте, организуйте и оценивайте свои карты Magic: The Gathering в одном месте.',
    },
    home: {
      title: 'TCG Stacked - Прокси-карты коллекционных карточных игр',
      description: 'Получите доступ к обширной библиотеке прокси-карт коллекционных карточных игр. Легко просматривайте и печатайте изображения карт для казуальной игры. Создайте колоду своей мечты уже сегодня!',
    },
    sets: {
      title: 'Сеты карт - MTG Proxies',
      description: 'Просматривайте все сеты MTG и печатайте прокси для своей колоды.',
    },
    tokens: {
      title: 'Токены - MTG Proxies',
      description: 'Улучшите свою игру в MTG с различными прокси-токенами.',
    },
    emblems: {
      title: 'Эмблемы - MTG Proxies',
      description: 'Печатайте прокси-карты эмблем MTG для своей колоды.',
    },
    search: {
      title: 'Поиск карт MTG - MTG Proxies',
      description: 'Легко находите и печатайте прокси-карты MTG. Используйте инструменты поиска для доступа к обширной базе данных и улучшайте свои колоды Magic: The Gathering с помощью прокси.',
    },
    support: {
      title: 'Поддержка - MTG Proxies',
      description: 'Отправьте нам письмо, если у вас есть вопросы, отзывы или вы хотите добавить токены/эмблемы.',
    },
    articles: {
      title: 'Статьи - MTG Proxies',
      description: 'Статьи о Magic: The Gathering и прокси-картах.',
    },
    import: {
      title: 'Импорт - MTG Proxies',
      description: 'Импортируйте список карт для печати прокси Magic: The Gathering.',
    },
    topProxies: {
      title: 'Популярные прокси - MTG Proxies',
      description: 'Смотрите самые популярные прокси-карты Magic: The Gathering.',
    },
    customCards: {
      title: 'Пользовательские карты - MTG Proxies',
      description: 'Создавайте свои собственные прокси-карты Magic: The Gathering.',
    },
    login: {
      title: 'Вход - MTG Proxies',
      description: 'Войдите в свой аккаунт для управления пользовательскими картами, списками колод и другим.',
    },
    register: {
      title: 'Регистрация - MTG Proxies',
      description: 'Зарегистрируйте аккаунт для управления пользовательскими картами, списками колод и другим.',
    },
    termsOfService: {
      title: 'Условия использования - MTG Proxies',
      description: 'Прочитайте условия использования сайта.',
    },
    privacyPolicy: {
      title: 'Политика конфиденциальности - MTG Proxies',
      description: 'Прочитайте политику конфиденциальности сайта.',
    },
    account: {
      title: 'Аккаунт - MTG Proxies',
      description: 'Управляйте своим аккаунтом.',
    },
    proMembership: {
      title: 'Pro-подписка - MTG Proxies',
      description: 'Оформите Pro-подписку для доступа ко всем функциям сайта.',
    },
    deckBuilder: {
      title: 'Конструктор колод - MTG Proxies',
      description: 'Создавайте и управляйте своими колодами Magic: The Gathering.',
    },
    deckEditor: {
      title: 'Редактор колод - MTG Proxies',
      description: 'Создавайте и редактируйте свои колоды Magic: The Gathering.',
    },
    publicDecks: {
      title: 'Публичные колоды - MTG Proxies',
      description: 'Просматривайте и исследуйте публичные колоды MTG, которыми поделилось сообщество.',
    },
  },
  pro: {
    pricing: {
      title: 'Разблокируйте Pro создание прокси-карт MTG',
      subtitle: 'Улучшите до Pro-подписки для создания прокси-карт без рекламы и доступа ко всем функциям и преимуществам.',
      monthlyPlan: 'Месячная Pro-подписка',
      yearlyPlan: 'Годовая Pro-подписка',
      monthlyPrice: '$5.00/месяц',
      yearlyPrice: '$40.00/год',
      subscribeMonthly: 'Подписаться на месяц',
      subscribeYearly: 'Подписаться на год',
      signInToSubscribe: 'Войдите для подписки',
      manageSubscription: 'Управление подпиской',
      nextBillingDate: 'Следующая дата оплаты',
      benefitsEndDate: 'Дата окончания преимуществ',
      viewInvoice: 'Посмотреть счёт',
      changePlan: 'Изменить план',
      reactivate: 'Возобновить',
      active: 'Активна',
      cancelled: 'Отменена',
      freeTrial: 'Бесплатный пробный период',
      freeTrialEnds: 'Бесплатный пробный период заканчивается',
      startFreeTrial: 'Начать 7-дневный бесплатный пробный период',
      signInForFreeTrial: 'Войдите для 7-дневного бесплатного пробного периода',
      current: 'Текущий',
    },
    benefits: {
      title: 'Почему вам нужна Pro-подписка TCG Stacked',
      subtitle: 'Присоединяйтесь к сотням игроков, которые улучшили свой опыт MTG с этими эксклюзивными Pro-функциями!',
      noAds: {
        title: 'Без рекламы',
        description: 'Просматривайте и создавайте прокси без раздражающей рекламы, баннеров и всплывающих окон. Наслаждайтесь чистым, сфокусированным опытом.',
      },
      darkMode: {
        title: 'Тёмная тема',
        description: 'Уменьшите нагрузку на глаза с элегантным тёмным интерфейсом. Идеально подходит для ночного просмотра и условий низкой освещённости.',
      },
      advancedSearch: {
        title: 'Расширенные фильтры поиска',
        description: 'Получите доступ к мощным фильтрам поиска для точного нахождения нужных карт. Фильтруйте по цветовой идентичности, редкости и типам карт.',
      },
      multipleDecks: {
        title: 'Управление несколькими колодами',
        description: 'Создавайте и управляйте несколькими колодами с конструктором колод. Сохраняйте все свои любимые колоды для быстрого доступа.',
      },
      futureFeatures: {
        title: 'Будущие Pro-функции',
        description: 'Получайте мгновенный доступ к новым премиум-функциям при их выпуске. Pro-участники всегда получают доступ первыми.',
      },
      cancelAnytime: {
        title: 'Отмена в любое время',
        description: 'Никаких долгосрочных обязательств. Вы можете гибко отменить подписку в любое время.',
      },
      prioritySupport: {
        title: 'Приоритетная поддержка',
        description: 'Пропустите очередь с выделенной приоритетной поддержкой. Ваши вопросы и проблемы будут рассмотрены первыми с особым вниманием.',
      },
    },
    features: {
      unlimitedDecks: 'Неограниченное создание колод',
      noAds: 'Без рекламы',
      prioritySupport: 'Приоритетная поддержка',
      darkMode: 'Доступ к тёмной теме',
      advancedSearch: 'Расширенные фильтры поиска',
    },
    promotion: {
      title: 'Улучшите до Pro для создания большего количества колод',
      description: 'Pro-участники могут создавать неограниченное количество колод. Улучшите сейчас, чтобы разблокировать эту функцию!',
      customizeTitle: 'Pro-функция: AI кастомизация карт',
      customizeDescription: 'Улучшите до Pro для создания пользовательских вариантов карт с помощью AI. Pro-участники могут генерировать до 5 пользовательских карт в день.',
      banner: 'Попробуйте Pro бесплатно в течение 7 дней! Без рекламы, тёмная тема, неограниченные колоды и многое другое.',
      tryNow: 'Попробовать сейчас',
    },
    account: {
      title: 'Pro-подписка',
      description: 'Управление вашими премиум-преимуществами',
      subscribeToPro: 'Подписаться на Pro',
    },
  },
  auth: {
    signIn: {
      title: 'Войти в свой аккаунт',
      withGoogle: 'Продолжить с Google',
      withEmail: 'Или продолжить с',
      sendMagicLink: 'Отправить магическую ссылку',
      noAccount: 'Нет аккаунта?',
      checkEmail: 'Проверьте свою почту на наличие ссылки для входа',
      errors: {
        failed: 'Ошибка входа',
        failedGoogle: 'Ошибка входа через Google',
        failedEmail: 'Ошибка входа по email',
        noEmail: 'Email не найден',
      },
      terms: 'Входя, вы соглашаетесь с:',
    },
    register: {
      title: 'Создать аккаунт',
      haveAccount: 'Уже есть аккаунт?',
      terms: 'Создавая аккаунт, вы соглашаетесь с:',
    },
    common: {
      termsOfService: 'Условия использования',
      privacyPolicy: 'Политика конфиденциальности',
      and: 'и',
    },
  },
  home: {
    hero: {
      title: 'Прокси',
      rotatingWords: ['карты', 'жетоны', 'эмблемы', 'мироходцы', 'командиры', 'земли', 'существа', 'артефакты', 'чары', 'мгновенные заклинания'],
      description: 'TCG Stacked помогает создавать прокси-карты коллекционных карточных игр для использования в ваших казуальных колодах совершенно бесплатно!',
      search: {
        cards: {
          tab: 'Карты',
          placeholder: 'Поиск коллекционной карты...',
          error: 'Не удалось загрузить случайные карты',
        },
        sets: {
          tab: 'Выпуски',
          placeholder: 'Поиск выпуска коллекционных карт...',
        },
        tokens: {
          tab: 'Жетоны',
          placeholder: 'Поиск жетона коллекционных карт...',
        },
        button: 'Поиск',
        hint: {
          cards: 'Нажмите Enter или кнопку Поиск, чтобы найти карты',
          sets: 'Нажмите Enter или кнопку Поиск, чтобы найти выпуски',
          tokens: 'Нажмите Enter или кнопку Поиск, чтобы найти жетоны',
        },
        aria: {
          searchIcon: 'Значок поиска',
          searchInput: {
            cards: 'Поиск карт',
            sets: 'Поиск выпусков',
            tokens: 'Поиск жетонов',
          },
        },
      },
      images: {
        cardAlt: 'Изображение карты Magic',
      },
      processedCount: '🎉 Мы обработали более {{count}} бесплатных прокси для сообщества! 🎉',
    },
    features: {
      section1: {
        badge: 'Печать Прокси',
        title: 'Печать Прокси-карт MTG',
        subtitle: 'Добавляйте карты в список печати, распечатывайте их и используйте в своих колодах уже сегодня!',
        features: [
          {
            name: 'Добавление карт в список печати',
            description: 'Ищите любую карту через страницу Поиска или просматривайте выпуски и добавляйте нужные карты в список печати.',
          },
          {
            name: 'Печать карт',
            description: 'После добавления всех нужных карт в список печати вы можете распечатать их и использовать в своих колодах.',
          },
          {
            name: 'Использование в колодах',
            description: 'После печати карт вы можете использовать их в своих колодах. Вырежьте их и приклейте на базовую землю или используйте протектор с базовой землей внутри.',
          },
        ],
        images: {
          cartScreenshot: 'Скриншот корзины, показывающий как добавлять карты в список печати',
        },
      },
      section2: {
        badge: 'Конструктор Колод',
        title: 'Создание и управление колодами Magic: The Gathering',
        subtitle: 'Создавайте и управляйте своими колодами или просматривайте публичные колоды, созданные сообществом.',
        features: [
          {
            name: 'Управление колодами MTG',
            description: 'Все пользователи могут создать и управлять одной колодой MTG. Pro-пользователи могут создавать неограниченное количество колод.',
          },
          {
            name: 'Печать карт',
            description: 'После добавления всех нужных карт в вашу колоду вы можете добавить их в Список Печати все сразу.',
          },
          {
            name: 'Просмотр публичных колод',
            description: 'Добавляйте целые колоды, созданные сообществом, в ваш Список Печати для легкого тестирования новых колод.',
          },
        ],
        images: {
          deckBuilderScreenshot: 'Интерфейс Конструктора Колод, показывающий как управлять колодами',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, Все права защищены.',
    disclaimer: 'TCG Stacked не производится, не одобряется, не поддерживается и не связан ни с одним издателем коллекционных карточных игр.',
    affiliate: 'Как партнер-аффилиат TCGplayer, TCG Stacked может получать комиссию за соответствующие покупки.',
    builtBy: 'Создано',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    support: 'Поддержка',
  },
  sort: {
    nameAsc: 'Имя (А до Я)',
    nameDesc: 'Имя (Я до А)',
    cmcAsc: 'Мана-стоимость (по возрастанию)',
    cmcDesc: 'Мана-стоимость (по убыванию)',
    usdAsc: 'Цена (по возрастанию)',
    usdDesc: 'Цена (по убыванию)',
    rarityAsc: 'Редкость (от обычной до мифической)',
    rarityDesc: 'Редкость (от мифической до обычной)',
    releasedDesc: 'Дата выпуска (сначала новые)',
    releasedAsc: 'Дата выпуска (сначала старые)',
  },
  pages: {
    search: {
      heading: 'Поиск',
    },
    sets: {
      heading: 'Сеты карт',
      latestSets: 'Последние сеты',
      upcomingSets: 'Предстоящие сеты',
      allSets: 'Все сеты',
      noResults: 'Результаты не найдены.',
    },
    set: {
      notFound: 'Сет не найден.',
      noCards: 'В этом сете не найдено карт.',
      addAll: 'Добавить {{count}} карт в список печати',
      addedToList: 'Добавлено {{count}} карт в список печати',
    },
    tokens: {
      heading: 'Токены',
    },
    emblems: {
      heading: 'Эмблемы',
    },
    import: {
      heading: 'Импорт карт в список печати',
      description: 'Введите названия всех карт, которые вы хотите добавить в список печати.',
    },
    topProxies: {
      heading: 'Популярные прокси',
      description: 'Вот 50 самых популярных прокси-карт Magic: The Gathering на MTG Proxies.',
    },
  },
  languages: {
    default: 'По умолчанию',
    any: 'Любой',
    english: 'Английский',
    spanish: 'Испанский',
    french: 'Французский',
    german: 'Немецкий',
    italian: 'Итальянский',
    portuguese: 'Португальский',
    japanese: 'Японский',
    korean: 'Корейский',
    russian: 'Русский',
    simplified_chinese: 'Упрощенный китайский',
    traditional_chinese: 'Традиционный китайский',
    hebrew: 'Иврит',
    latin: 'Латинский',
    ancient_greek: 'Древнегреческий',
    arabic: 'Арабский',
    sanskrit: 'Санскрит',
    phyrexian: 'Фирексийский',
    quenya: 'Квенья',
  },
  filters: {
    show: '✨ Показать Pro фильтры',
    hide: '✨ Скрыть Pro фильтры',
  },
  search: {
    showing_start: 'Показано',
    showing_to: 'до',
    showing_of: 'из',
    showing_results: 'результатов',
    noResults: 'Результаты не найдены.',
    useSearchTip: 'Используйте поиск вверху страницы, чтобы найти карту.',
  },
  advancedFilters: {
    colors: 'Цвета',
    rarity: 'Редкость',
    cardTypes: 'Типы карт',
    format: 'Формат',
    manaValue: 'Мана-стоимость',
    cardName: 'Название карты',
    cardText: 'Текст карты',
    specialCharacteristics: 'Особые характеристики',
    activeFilters: 'Активные фильтры',
    clearAll: 'Очистить все',
    applyFilters: 'Применить фильтры',
    searchCardName: 'Поиск по названию карты...',
    searchCardText: 'Поиск по тексту карты...',
    namePrefix: 'Название: ',
    manaPrefix: 'Мана: ',
    textPrefix: 'Текст: ',
    removeFromFilter: '✕',
    selectLanguage: 'Выбрать язык',
  },
  card: {
    addToPrintList: 'Добавить в список печати',
    removeFromPrintList: 'Удалить из списка печати',
    cardsInPrintList: 'карта в списке печати',
    cardsInPrintListPlural: 'карт в списке печати',
    buyOn: 'Купить на TCGplayer',
    buyFor: 'Купить за ',
    viewDetails: 'Подробности',
    type: 'Тип',
    manaCost: 'Стоимость маны',
    rarity: 'Редкость',
    artist: 'Художник',
    collectorNumber: 'Номер коллекционера',
    oracleText: 'Текст оракула',
    youMightAlsoLike: 'Вам также может понравиться...',
    noRecommendations: 'В данный момент нет рекомендаций.',
    details: 'Подробности',
    rulings: 'Правила',
    legality: 'Легальность',
    share: 'Поделиться',
    favorite: 'Избранное',
    noRulings: 'Для этой карты нет правил.',
    noLegalityInfo: 'Для этой карты нет информации о легальности.',
    published: 'Опубликовано',
    legal: 'Легально',
    restricted: 'Ограничено',
    banned: 'Запрещено',
    format: 'Формат',
    status: 'Статус',
    viewMore: 'Показать больше',
    viewLess: 'Показать меньше',
    customizeWithAI: 'Настроить с помощью ИИ',
    otherVersions: 'Уникальные печати',
    showUniqueVersions: 'Показать уникальные печати',
    hideUniqueVersions: 'Скрыть уникальные печати',
  },
  cart: {
    title: 'Список печати',
    closePanel: 'Закрыть панель',
    empty: 'В списке печати нет прокси.',
    addPadding: 'Добавить отступы',
    paperSize: 'Размер бумаги',
    scale: 'Масштаб',
    clearCardList: 'Очистить список',
    print: 'Печать',
    success: 'Успех!',
  },
  setsList: {
    showing: 'Показано',
    to: 'до',
    of: 'из',
    results: 'результатов',
    searchPlaceholder: 'Поиск...',
  },
  customizeCardModal: {
    title: 'Настройка карты с помощью ИИ',
    description: 'Опишите, как вы хотите настроить эту карту. ИИ создаст новую версию, сохраняя рамку и структуру карты.',
    buttonText: 'Настроить с помощью ИИ',
    placeholder: 'Опишите ваш вариант настройки карты...',
    generateButton: 'Создать пользовательскую карту',
    generatingButton: 'Создание...',
    addToPrintListButton: 'Добавить в список печати',
    successMessage: 'Пользовательская карта добавлена в список печати',
    remainingGenerationsOne: 'Осталось {{count}} генерация в этом месяце',
    remainingGenerationsOther: 'Осталось {{count}} генераций в этом месяце',
    error: {
      failed: 'Не удалось создать пользовательскую карту',
    },
  },
  collection: {
    title: 'Моя коллекция',
    loginRequired: 'Требуется вход',
    loginMessage: 'Пожалуйста, войдите, чтобы просмотреть свою коллекцию',
    emptyCollection: 'Карты не найдены',
    emptyCollectionMessage: 'Ваша коллекция пуста. Добавьте карты со страницы подробностей карты или используйте функцию массового добавления.',
    noMatchingCards: 'Нет карт, соответствующих вашим фильтрам.',
    searchPlaceholder: 'Поиск карт...',
    sortBy: 'Сортировать по',
    sortName: 'Названию',
    sortPrice: 'Цене',
    sortDate: 'Дате добавления',
    sortQuantity: 'Количеству',
    filterRarity: 'Редкость',
    filterSet: 'Сет',
    allRarities: 'Все редкости',
    allSets: 'Все сеты',
    filters: 'Фильтры',
    clearFilters: 'Очистить фильтры',
    sortAscending: 'Сортировать по возрастанию',
    sortDescending: 'Сортировать по убыванию',
    bulkAdd: 'Массовое добавление',
    bulkAddTitle: 'Добавить карты из списка печати',
    bulkAddDescription: 'Добавьте все карты из списка печати в вашу коллекцию.',
    addToCart: 'Добавить в список печати',
    addedToCart: 'Добавлено в список печати',
    stats: 'Статистика',
    totalValue: 'Общая стоимость',
    filteredValue: 'Отфильтрованная стоимость',
    cardCount: 'Количество карт',
    totalCards: 'Всего карт',
    uniqueCards: 'Уникальных карт',
    filteredCards: 'Отфильтрованных карт',
    rarityBreakdown: 'Распределение по редкости',
    export: 'Экспорт коллекции',
    exporting: 'Экспорт...',
    exportSuccess: 'Коллекция успешно экспортирована',
    exportError: 'Ошибка экспорта коллекции',
    noCardsToExport: 'Нет карт для экспорта',
    exportCardName: 'Название карты',
    exportSet: 'Сет',
    exportRarity: 'Редкость',
    exportQuantity: 'Количество',
    exportPrice: 'Цена',
    exportTotalValue: 'Общая стоимость',
    exportDateAdded: 'Дата добавления',
    // Quick add feature
    quickAdd: 'Быстрое добавление',
    searchCards: 'Поиск карт для добавления',
    typeToSearch: 'Введите минимум 3 символа для поиска',
    noResults: 'Результаты не найдены',
    noCardSelected: 'Карта не выбрана',
    addCardToCollection: 'Добавить карту в коллекцию',
    addCardDescription: 'Укажите количество для добавления в коллекцию',
    quantity: 'Количество',
    price: 'Цена',
    // Insights
    insights: 'Аналитика коллекции',
    noInsightsAvailable: 'Для вашей коллекции нет доступной аналитики',
    insightsDescription: 'Подробная статистика о вашей коллекции',
    rarityDistribution: 'Распределение по редкости',
    topSets: 'Популярные сеты',
    priceDistribution: 'Распределение по цене',
    // Clear collection feature
    clearCollection: 'Очистить коллекцию',
    clearCollectionConfirmTitle: 'Очистить всю коллекцию?',
    clearCollectionConfirmMessage: 'Это действие нельзя отменить. Все карты в вашей коллекции будут безвозвратно удалены.',
    // Edit card in collection
    editCardInCollection: 'Редактировать карту в коллекции',
    editCardDescription: 'Обновите детали этой карты в вашей коллекции.',
    viewCardDetails: 'Просмотреть детали карты',
    condition: 'Состояние',
    selectCondition: 'Выберите состояние',
    language: 'Язык',
    selectLanguage: 'Выберите язык',
    finish: 'Отделка',
    selectFinish: 'Выберите отделку',
    purchasePrice: 'Цена покупки',
    isProxy: 'Это прокси',
    saveChanges: 'Сохранить изменения',
    removeCard: 'Удалить карту',
    cardRemoved: 'Карта удалена из коллекции',
    errorRemovingCard: 'Ошибка при удалении карты из коллекции',
    errorSavingChanges: 'Ошибка при сохранении изменений карты',
  },
  feedback: {
    buttonLabel: 'Обратная связь',
    title: 'Поделитесь своим мнением',
    description: 'Мы ценим ваше мнение для улучшения TCG Stacked. Пожалуйста, поделитесь своими мыслями с нами.',
    categoryLabel: 'Категория',
    categories: {
      bug: 'Сообщение об ошибке',
      feature: 'Запрос функции',
      improvement: 'Предложение по улучшению',
      general: 'Общий отзыв',
      other: 'Другое',
    },
    messageLabel: 'Ваш отзыв',
    messagePlaceholder: 'Пожалуйста, поделитесь своими мыслями, предложениями или сообщите о проблеме...',
    ratingLabel: 'Оцените ваш опыт (Необязательно)',
    emailLabel: 'Email (Необязательно)',
    emailPlaceholder: 'ваш@email.com',
    emailHelp: 'Укажите ваш email, если вы хотите, чтобы мы связались с вами.',
    submitting: 'Отправка...',
    submitButton: 'Отправить отзыв',
    successMessage: 'Спасибо за ваш отзыв!',
    errorMessage: 'Не удалось отправить отзыв. Пожалуйста, попробуйте еще раз.',
  },
  hero: {
    game: {
      pokemon: {
        tab: 'Покемон',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'Поиск любой карты...',
      },
      sets: {
        placeholder: 'Поиск любого набора карт...',
      },
      button: 'Поиск',
      hint: {
        cards: 'Нажмите Enter или кнопку Поиск, чтобы найти карты',
        sets: 'Нажмите Enter или кнопку Поиск, чтобы найти наборы',
      },
      aria: {
        searchIcon: 'Иконка поиска',
        searchInput: {
          cards: 'Поиск карт',
          sets: 'Поиск наборов',
        },
      },
    },
  },
  customizeCardModal: {
    title: 'Настройка карты с помощью ИИ',
    description: 'Опишите, как бы вы хотели настроить эту карту. ИИ создаст новую версию, сохраняя рамку и структуру карты.',
    buttonText: 'Настроить с помощью ИИ',
    placeholder: 'Опишите вашу пользовательскую вариацию карты...',
    generateButton: 'Создать пользовательскую карту',
    generatingButton: 'Создание...',
    addToPrintListButton: 'Добавить в список печати',
    successMessage: 'Пользовательская карта добавлена в список печати',
    remainingGenerationsOne: '{{count}} оставшаяся генерация в этом месяце',
    remainingGenerationsOther: '{{count}} оставшихся генераций в этом месяце',
    error: {
      failed: 'Не удалось создать пользовательскую карту',
    },
  },
  pages: {
    search: {
      heading: 'Поиск',
    },
    sets: {
      heading: 'Наборы карт',
      latestSets: 'Последние наборы',
      upcomingSets: 'Предстоящие наборы',
      allSets: 'Все наборы',
      noResults: 'Результаты не найдены.',
    },
    set: {
      notFound: 'Набор не найден.',
      noCards: 'В этом наборе не найдено карт.',
      addAll: 'Добавить {{count}} карт в список печати',
      addedToList: 'Добавлено {{count}} карт в список печати',
    },
    tokens: {
      heading: 'Токены',
    },
    emblems: {
      heading: 'Эмблемы',
    },
    import: {
      heading: 'Импорт карт в список печати',
      description: 'Введите названия всех карт, которые вы хотите добавить в список печати.',
    },
    topProxies: {
      heading: 'Популярные прокси',
      description: 'Вот 50 самых популярных прокси-карт MTG на TCG Stacked.',
    },
  },
  mtg: {
    hero: {
      title: 'Прокси',
      rotatingWords: ['Карты', 'Земли', 'Существа', 'Артефакты', 'Planeswalkers'],
      description: 'Ищите, просматривайте и создавайте прокси для карт коллекционной карточной игры Magic: The Gathering.',
      search: {
        cards: {
          tab: 'Карты',
          placeholder: 'Поиск любой карты MTG...',
          error: 'Не удалось загрузить случайные карты MTG',
        },
        sets: {
          tab: 'Наборы',
          placeholder: 'Поиск любого набора карт MTG...',
        },
        button: 'Поиск',
        hint: {
          cards: 'Нажмите Enter или кнопку Поиск, чтобы найти карты',
          sets: 'Нажмите Enter или кнопку Поиск, чтобы найти наборы',
        },
        aria: {
          searchIcon: 'Иконка поиска',
          searchInput: {
            cards: 'Поиск карт Magic',
            sets: 'Поиск наборов Magic',
          },
        },
      },
      images: {
        cardAlt: 'Изображение карты Magic',
      },
      processedCount: 'Исследуйте более {{count}} карт Magic: The Gathering в нашей базе данных!',
    },
  },
  pokemon: {
    hero: {
      title: 'Прокси',
      rotatingWords: ['Карты', 'Покемоны', 'Тренеры', 'Энергия', 'Стадионы'],
      description: 'Ищите, просматривайте и создавайте прокси для карт коллекционной карточной игры Покемон.',
      search: {
        cards: {
          tab: 'Карты',
          placeholder: 'Поиск любой карты Покемон...',
          error: 'Не удалось загрузить случайные карты Покемон',
        },
        sets: {
          tab: 'Наборы',
          placeholder: 'Поиск любого набора карт Покемон...',
        },
        button: 'Поиск',
        hint: {
          cards: 'Нажмите Enter или кнопку Поиск, чтобы найти карты',
          sets: 'Нажмите Enter или кнопку Поиск, чтобы найти наборы',
        },
        aria: {
          searchIcon: 'Иконка поиска',
          searchInput: {
            cards: 'Поиск карт Покемон',
            sets: 'Поиск наборов Покемон',
          },
        },
      },
      images: {
        cardAlt: 'Изображение карты Покемон',
      },
      processedCount: 'Исследуйте более {{count}} карт Покемон в нашей базе данных!',
    },
    sets: {
      heading: 'Наборы карт Покемон',
      latestSets: 'Последние наборы',
      upcomingSets: 'Предстоящие наборы',
      allSets: 'Все наборы',
      noResults: 'Результаты не найдены.',
      sortBy: 'Сортировать по',
      sort: {
        nameAsc: 'Имя (А до Я)',
        nameDesc: 'Имя (Я до А)',
        releaseDateDesc: 'Дата выпуска (сначала новые)',
        releaseDateAsc: 'Дата выпуска (сначала старые)',
      },
      filterBy: 'Фильтровать по серии',
      allSeries: 'Все серии',
    },
    set: {
      notFound: 'Набор Покемон не найден.',
      backToSets: 'Назад к наборам',
      cards: 'карт',
      released: 'Выпущено',
      noCards: 'В этом наборе не найдено карт.',
      tryAdjusting: 'Попробуйте изменить параметры поиска, чтобы найти то, что вы ищете.',
      sortBy: 'Сортировать по',
      filterBy: 'Фильтровать по',
      allTypes: 'Все типы',
      allRarities: 'Все редкости',
      searchPlaceholder: 'Поиск карт в этом наборе...',
    },
    card: {
      notFound: 'Карта Покемон не найдена.',
      backToSearch: 'Назад к поиску',
      addToPrintList: 'Добавить в список печати',
      removeFromPrintList: 'Удалить из списка печати',
      inPrintList: 'В списке печати',
      buyOn: 'Купить на TCGplayer',
      details: 'Детали',
      type: 'Тип',
      rarity: 'Редкость',
      set: 'Набор',
      artist: 'Художник',
      number: 'Номер карты',
      flavorText: 'Художественный текст',
      attacks: 'Атаки',
      abilities: 'Способности',
      weakness: 'Слабость',
      resistance: 'Сопротивление',
      retreatCost: 'Стоимость отступления',
      legality: 'Легальность',
      otherVersions: 'Другие версии',
      youMightAlsoLike: 'Вам также может понравиться...',
    },
  },
  creditPurchaseModal: {
    title: 'Купить AI-кредиты генерации',
    description: 'Купите дополнительные AI-кредиты для настройки большего количества карт.',
    buttonText: 'Купить кредиты',
    currentCredits: 'Текущие кредиты',
    selectPackage: 'Выбрать пакет кредитов',
    purchase: 'Купить сейчас',
    noCreditsWarning: 'Нет доступных кредитов',
    lowCreditsWarning: 'Мало оставшихся кредитов',
    buyCredits: 'Купить кредиты',
    remainingGenerationsOne: '{{count}} кредит',
    remainingGenerationsOther: '{{count}} кредитов',
    creditPackages: {
      small: 'Маленький',
      medium: 'Средний',
      large: 'Большой',
    },
    loadingCredits: 'Загрузка информации о кредитах...',
    valuePerCredit: '${value}/кредит',
    credits: 'Кредиты',
    failedCheckout: 'Не удалось создать сессию оплаты',
  },
  ai: {
    pageTitle: 'Настройте свои прокси-карты с помощью AI Magic | TCG Stacked',
    pageDescription: 'Трансформируйте свои карты Magic: The Gathering с помощью AI-генерации изображений. Эксклюзивно для Pro-участников.',
    hero: {
      badge: 'Pro-функция',
      title: 'Настройте свои прокси-карты с помощью AI Magic',
      subtitle: 'Создавайте пользовательские изображения для ваших прокси Magic: The Gathering за секунды',
      cta: 'Попробуйте Pro-подписку бесплатно',
    },
    features: {
      title: 'Мощные AI-функции на кончиках пальцев',
      subtitle: 'Наша AI-настройка даёт вам полный творческий контроль над вашими прокси-картами Magic: The Gathering',
      cardIntegrity: {
        title: 'Сохранение целостности карты',
        description: 'Наш AI изменяет только изображение, сохраняя рамку карты, текст, символы маны и макет в неизменном виде.',
      },
      creativity: {
        title: 'Безграничная креативность',
        description: 'Трансформируйте свои карты в любой стиль или тему, которые только можете представить - от фэнтези до научной фантастики, от фотореализма до абстракции.',
      },
      instantResults: {
        title: 'Мгновенные результаты',
        description: 'Генерируйте пользовательские изображения за секунды без навыков дизайна. Просто опишите, что вы хотите увидеть.',
      },
      saveCreations: {
        title: 'Сохраняйте свои творения',
        description: 'Все ваши AI-сгенерированные карты сохраняются в вашем аккаунте, чтобы вы могли получить к ним доступ в любое время из вашей панели управления.',
      },
      printAnytime: {
        title: 'Печатайте в любое время',
        description: 'Добавляйте свои пользовательские карты в список прокси в любое время и печатайте их вместе с остальной коллекцией.',
      },
    },
    credits: {
      title: 'AI-кредиты генерации',
      subtitle: 'Настраивайте и трансформируйте свои прокси-карты Magic: The Gathering с помощью мощных, доступных и простых в использовании AI-кредитов генерации.',
      howItWorks: 'Как работают кредиты',
      step1: {
        number: '1',
        title: 'Покупайте кредиты',
        description: 'в пакетах, которые соответствуют вашим творческим потребностям и бюджету',
      },
      step2: {
        number: '2',
        title: 'Генерируйте пользовательские изображения',
        description: 'для любой прокси-карты Magic: The Gathering, используя 1 кредит на генерацию',
      },
      step3: {
        number: '3',
        title: 'Отслеживайте использование',
        description: 'в панели управления вашего аккаунта и покупайте больше в любое время',
      },
      proAdvantage: {
        title: 'Преимущество Pro-участника',
        description: 'Pro-участники получают 5 ежемесячных AI-кредитов генерации в рамках подписки. Присоединяйтесь к Pro, чтобы максимизировать свой творческий потенциал!',
      },
      purchaseButton: 'Купить кредиты сейчас',
      unlockProButton: 'Разблокировать Pro-подписку',
      packages: {
        title: 'Пакеты кредитов',
        small: {
          name: 'Маленький',
          credits: '5',
          price: '2.99',
          value: '$0.60/кредит',
        },
        medium: {
          name: 'Средний',
          credits: '15',
          price: '7.99',
          value: '$0.53/кредит',
          popular: 'Популярный',
        },
        large: {
          name: 'Большой',
          credits: '30',
          price: '13.99',
          value: '$0.47/кредит',
        },
        createDesigns: 'Создайте {{credits}} уникальных дизайнов карт',
      },
    },
  },
};

export default translations;
